import { instance } from "./api"
import { useAuthStore } from '../stores/t-auth';
import type { UploadFilePayload } from "../types"

export async function uploadFileService(payload: UploadFilePayload): Promise<any> {
    const auth = useAuthStore();

    try {
        const response = await instance.post('/files/upload', payload, {
            headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + auth.token,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error uploading file:', error);
        throw error;
    }
}
export default {
    uploadFileService
};